import { useTheme } from "PFApp/theme_context_provider/theme_context_provider_context";
import { Icon } from "PFComponents/icon";
import { useTranslation } from "react-i18next";

import { NavItem } from "../parts/nav_item";

export const AnalyticsNavItem = (props) => {
  const { t } = useTranslation("translation", { keyPrefix: "navBar.items" });
  const { themeVars } = useTheme();

  return (
    <NavItem
      icon={<Icon name="insights" fill={themeVars["paletteWhite0"]} />}
      isActiveTest={(path) => path.match(/^\/analytics/)}
      {...props}
      name={t("analytics")}
      id="analytics"
      href="/analytics"
    />
  );
};
